<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="region-featured-products-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header-container">
                        <h2
                            class="title"
                            v-test:title
                        >
                            {{ title }}
                        </h2>
                    </div>
                    <div class="listings-container">
                        <product-listings
                            :items="products"
                        />
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import ProductListings from '../../molecules/ProductListings/ProductListings.vue';

    export default {
        name: 'region-featured-products-section',

        components: { ProductListings },

        props: {
            title: {
                type: String,
                required: true,
                default: '',
            },

            products: {
                type: Array,
                required: true,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .region-featured-products-section {
        padding: 40px 0;
    }

    .title {
        margin-bottom: 40px;
        font-weight: bold;
    }

    .mobile-gutter {
        @include media-breakpoint-up(sm) {
            padding: 0;
        }
    }

    .listings-container {
        @include media-breakpoint-up(xl) {
            padding-left: 80px;
            padding-right: 80px;
        }
    }
</style>
